export const ACCOUNT_SCOPED_TRANSIENT_KEYS = [
  'selectedConversationId',
  'tempContactName',
  'tempContactPhone',
  'tempContactId',
] as const;

export function clearAccountScopedStorage(): void {
  if (typeof window === 'undefined') return;
  for (const key of ACCOUNT_SCOPED_TRANSIENT_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
    }
  }
}

export function accountStorageKey(baseKey: string, accountId: string | null | undefined): string {
  return `${baseKey}::ba:${accountId || 'none'}`;
}
